// extracted by mini-css-extract-plugin
export var bodySections = "_ca-8";
export var gray = "_ca-7";
export var green = "_ca-4";
export var iconContainer = "_ca-9";
export var iconWidgetContainer = "_ca-1";
export var phoneIcon = "_ca-2";
export var red = "_ca-5";
export var statusDot = "_ca-3";
export var widgetContainer = "_ca-0";
export var yellow = "_ca-6";